/**
 * clipping-indicators.js
 *
 * Takes top clipped slides from a presentation on the slideview page and
 * reveals them with small indicators across the progress bar in the toolbar.
 *
 */

(function(window, ss, exports) {
      // Classes
  var classes = {
      clippingIndicator: 'clipping-indicator'
    },

    // Selectors
    selectors = {
      bufferedBar: '.buffered-bar'
    },

    // Config
    DEFAULT_CONFIG = {
      topClips: null,
      slideCount: null
    };

  /**
   * Creates a new ClippingIndicators instance with optional configuration.
   * @param options            {Object} Configurable options for instance.

   *
   * @param option.totalSlides {Object} The total number of slides in the presentation.
   * @param option.totalClips {Array} The total number of slides in the presentation.
   * @constructor
   */
  function ClippingIndicators(options) {
    this.config = $.extend( {}, DEFAULT_CONFIG, options);
    this._init();
  }

  ClippingIndicators.prototype = /** @lends ClippingIndicators.prototype */ {

    constructor: ClippingIndicators,

    /**
     * Initializes clipping indicators.
     * @returns {void}
     */
    _init: function() {
      this.$bufferedBar = $(selectors.bufferedBar);
      this.slideCount = this.config.slideCount;
      this.topClips = this.config.topClips;

      if (this.slideCount && this.topClips) {
        this._attachIndicators();
      }
    },

    /**
     * Takes top clipped slide data and appends generated indicators to the
     * progress bar in the toolbar.
     * @returns {void}
     */
    _attachIndicators: function() {
      if (this.topClips) {
        var buffer = [];

        $.each(this.topClips, function(position, clip) {
          var $item = this._createIndicator(clip);

          if ($item.prop('style').left) {
            buffer.push($item);
          }
        }.bind(this));

        this.$bufferedBar.append(buffer);
      }
    },

    /**
     * Generates the indicator templates for the progress bar.
     * @returns {jQuery}
     */
    _createIndicator: function(clip) {
      /**
       * Calculates the left offset value for the indicator.
       * @returns {String} the inline style left property value.
       */
      function calcLeftVal(position, slideCount) {
        var leftOffsetAsPercent = ((parseInt(position, 10) / slideCount) * 100),
          // Percentage one slide takes up in overall width of progress bar.
          slideWidthAsPercent = 100 / slideCount;

        // Subtracts half of slide width percentage in order to center
        // indicator along its slide buffer segment.
        return (leftOffsetAsPercent) - (slideWidthAsPercent / 2) + '%';
      }

      return $('<div/>')
                .addClass(classes.clippingIndicator)
                .css('left', calcLeftVal(clip.position, this.slideCount));
    }

  };

  // Export as module
  exports('ClippingIndicators', ClippingIndicators);
}(window, window.slideshare_object, window.slideshare_object.utils.exports));
